import { render, staticRenderFns } from "./Salesmans-company.vue?vue&type=template&id=4eb4a87f"
import script from "./Salesmans-company.vue?vue&type=script&lang=js"
export * from "./Salesmans-company.vue?vue&type=script&lang=js"
import style0 from "./Salesmans-company.vue?vue&type=style&index=0&id=4eb4a87f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports